'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationAlert', ['$scope', '$stateParams', '$state', 'Alerts', '$rootScope',
        function ($scope, $stateParams, $state, Alerts, $rootScope) {
        $scope.resetInvestigation();
        $scope.investigation_alert = $stateParams.investigation_alert;
        $scope.investigationAlertID = $stateParams.investigationAlertID;
        $scope.saving = false;
        $scope.retiring = false;
        $scope.unretiring = false;
        $scope.loading = true;
        
        if ($stateParams.investigationAlertID != null) {
            Alerts.getByID($stateParams.investigationAlertID).then(function (alert) {
                $scope.investigation_alert = alert;
                $scope.loading = false;
            })
        }
        else {
            $scope.investigation_alert = {};
            $scope.loading = false;
        }

        $scope.save = function () {
            $scope.saving = true;

            Alerts.save($scope.investigation_alert, $scope.investigationID).then(function (alert) {
                updateArray($scope.investigation.alerts, alert);
                updateArray($scope.masterInvestigation.alerts, alert);
                $state.go('internal.licensing.investigation.alerts', { id: $scope.investigationID });
                $scope.saving = false;
            });
        }

        $scope.retire = function () {
            $scope.retiring = true;
            $scope.investigation_alert.retired = true;
            $scope.investigation_alert.retired_on = new Date();
            $scope.investigation_alert.retired_by = $rootScope.userAccount.id;

            Alerts.save($scope.investigation_alert).then(function (alert) {
                $scope.investigation_alert = alert;
                updateArray($scope.investigation.alerts, alert);
                updateArray($scope.masterInvestigation.alerts, alert);
                $scope.retiring = false;
            });
        }

        $scope.unretire = function () {
            $scope.unretiring = true;
            $scope.investigation_alert.retired = false;
            $scope.investigation_alert.retired_on = null;

            Alerts.save($scope.investigation_alert).then(function (alert) {
                $scope.investigation_alert = alert;
                updateArray($scope.investigation.alerts, alert);
                updateArray($scope.masterInvestigation.alerts, alert);
                $scope.unretiring = false;
            });
        }

        $scope.typeChange = function (alert) {
            alert.alert_type_id = alert.alert_type.id;
            alert.message = alert.alert_type.message;
            
            if (alert.alert_type.days_to_retire != null && alert.alert_type.days_to_retire > 0) {
                alert.retired_on = new Date();
                alert.retired_on.setHours(0, 0, 0, 0);
                alert.retired_on.setDate(alert.retired_on.getDate() + alert.alert_type.days_to_retire);
            }
        }
    }])
;